import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives } from "vue";
import { computed } from "vue";
import Icon from "./Icon.vue";
import { useI18n } from "vue-i18n";
import BadgeComponent from "./BadgeComponent.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NavigationItem',
    props: {
        item: {},
        type: {},
        translationPrefix: {},
        iconStyle: {}
    },
    setup(__props) {
        const props = __props;
        const { t, te } = useI18n();
        const label = computed(() => itemLabel(props.item));
        function itemLabel(item) {
            if (!item.label) {
                return t((props.translationPrefix ?? 'nav.') + item.name);
            }
            if (te(item.label)) {
                return t(item.label);
            }
            return item.label;
        }
        function itemProps() {
            if (props.item.url) {
                return { href: props.item.url };
            }
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(__props.item.url ? 'a' : 'router-link'), _mergeProps({
                to: __props.item.url ? undefined : { name: __props.item.name },
                class: (__props.type ?? 'main') + '-nav__item',
                title: label.value
            }, itemProps(), {
                "active-class": (__props.type ?? 'main') + '-nav__item--active'
            }), {
                default: _withCtx(() => [
                    (__props.item.navItemComponent)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.item.navItemComponent.component), {
                            key: 0,
                            item: __props.item
                        }, null, 8, ["item"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (__props.item.icon)
                                ? (_openBlock(), _createBlock(Icon, {
                                    key: 0,
                                    name: __props.item.icon,
                                    class: _normalizeClass((__props.type ?? 'main') + '-nav__item-icon'),
                                    "icon-style": __props.iconStyle ?? 'regular'
                                }, null, 8, ["name", "class", "icon-style"]))
                                : _createCommentVNode("", true),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("span", {
                                class: _normalizeClass((__props.type ?? 'main') + '-nav__item-text')
                            }, _toDisplayString(label.value), 3),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            (__props.item.badge)
                                ? (_openBlock(), _createBlock(BadgeComponent, { key: 1 }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(__props.item.badge), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ], 64))
                ]),
                _: 1
            }, 16, ["to", "class", "title", "active-class"])), [
                [_vShow, !__props.item.hidden]
            ]);
        };
    }
});
